import React from 'react'
import { ReceiptCard, styled } from '~/app/components'
import InformationPanel, {
  InformationFormat,
} from '~/app/components/order-list/details/InformationPanel'
import SubHeader from '../../common/SubHeader/SubHeader'
import ReceiptBottom from '~/app/imgs/bd-receipt-bottom.svg?inline'

/**
 * PaymentInformation component
 * author: soojin.oh
 */

// type definitions
type PaymentInformationProps = {
  payment: Array<InformationFormat>
  isReceiptCard?: boolean
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div`
  position: relative;
  background: ${({ theme }) => theme.color.white};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
  padding-bottom: 2rem;
  box-shadow: 0 0.2rem 0.2rem 0 ${({ theme }) => theme.color.black_op10};
  ::after {
    content: '';
    border-bottom: 0.9rem solid transparent;
    border-image: url(${ReceiptBottom}) 0 0 100% 0 round;
    position: relative;
    bottom: -2.4rem;
    display: block;
    margin: 0 2rem 0;
  }
`

const PaymentCard = styled(props => <ReceiptCard {...props} />)`
  margin-top: 0;
`

// PaymentInformation component
const PaymentInformation: React.FunctionComponent<PaymentInformationProps> = function ({
  payment,
  style,
  isReceiptCard,
}) {
  return isReceiptCard ? (
    <PaymentCard title="결제 금액" isDisabledViewDetail={isReceiptCard}>
      <InformationPanel information={payment} />
    </PaymentCard>
  ) : (
    <Container style={style}>
      <SubHeader title="결제 금액" hasBottomContent />
      <InformationPanel information={payment} />
    </Container>
  )
}

export default PaymentInformation
